<template>
  <div class="about t-al-l" style="background-color: #ffffff;min-height: 100%;">

    <div v-html="essay" style="padding: 12px;font-size: 12px;"></div>

    <div style="height: 60px;">

    </div>
  </div>
</template>

<script>
import common from '../assets/js/common'
import addone from '../components/addone'
import stroe from '../store'

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components:
      {
        addone
      },
  data: function(){
    return {
      roleCn:'',
      phone:'',
      essay: '',
      activeNames: []
    }
  },
  methods:{
    initPage:function()
    {
      common.cusHttp(this,'/boot/question.php').then((res)=>{
        // console.log(res.data);
        res = JSON.parse(res.data)
        // this.list = res.data.data
        if( this.$route.query.type == 'about' )
        {
          this.essay = res.data.about_us
        }else if( this.$route.query.type == 'safe_ensure')
        {
          this.essay = res.data.safe_ensure
        }
      })
    },
    resetPassword:function()
    {
    }
  },
  created:function()
  {
  },
  mounted()
  {
    // alert('ִ��')
    // this.$emit('committarbar',2)
    this.initPage();
  },
  onShow()
  {
  },
  computed:{
  }
}
</script>

<style scoped>
.fs-14-fc-ffffff
{
  color: #ffffff;;
  font-size: 0.4375rem;
  font-family: PingFangSC-Medium;
  line-height: 0.525rem;
}
</style>
